import { usePDFPrintHook } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { AccessControl } from "@careinfo/permission-required";

export default function OrderMenu(props: any) {
  const [searchParams, setSearchParms] = useSearchParams();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handleButtonClick = (type: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    } else if (selectedOrder?.length > 1 && type === "Change Status") {
      toast.error("Please select one order first");
      return;
    }
    props?.setOrderActionMenu(true);
    props?.setActionType(type);
  };

  const handleLabelPrintDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  const handleOrderReceiptDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } catch (err) {
      console.error(err);
    }
  };

  const handlePODReceiptDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}order-pod-print/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } catch (err) {
      console.error(err);
    }
  };

  const handleTAXInvoiceDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.TAX_INVOICE}`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`top-16 text-right`}>
      <Menu as="div" className={tw`relative inline-block text-left`}>
        <div>
          <Menu.Button
            className={tw`inline-flex w-full justify-center rounded-md text-primary px-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            Action
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter={tw`transition ease-out duration-100`}
          enterFrom={tw`transform opacity-0 scale-95`}
          enterTo={tw`transform opacity-100 scale-100`}
          leave={tw`transition ease-in duration-75`}
          leaveFrom={tw`transform opacity-100 scale-100`}
          leaveTo={tw`transform opacity-0 scale-95`}
        >
          <Menu.Items
            className={tw`absolute z-[100] mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none right-0`}
          >
            <>
              <div className={tw`px-1 py-1`}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => handleButtonClick("Change Status")}
                      className={tw`${
                        active ? "bg-primary text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      Change Status
                    </button>
                  )}
                </Menu.Item>
              </div>
            </>
            <AccessControl allowedPermissions={["can_print"]}>
              <div className={tw`px-1 py-1`}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLabelPrintDownload}
                      className={tw`${
                        active ? "bg-primary text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      Label Print
                    </button>
                  )}
                </Menu.Item>
              </div>
            </AccessControl>
            <AccessControl allowedPermissions={["can_print"]}>
              <div className={tw`px-1 py-1`}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => handleOrderReceiptDownload()}
                      className={tw`${
                        active ? "bg-primary text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      Order Receipt
                    </button>
                  )}
                </Menu.Item>
              </div>
            </AccessControl>
            <AccessControl allowedPermissions={["can_print"]}>
              <div className={tw`px-1 py-1`}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => handlePODReceiptDownload()}
                      className={tw`${
                        active ? "bg-primary text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      POD Receipt
                    </button>
                  )}
                </Menu.Item>
              </div>
            </AccessControl>
            {/* <AccessControl allowedPermissions={["can_print"]}>
              <div className={tw`px-1 py-1`}>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => handleTAXInvoiceDownload()}
                      className={tw`${
                        active ? "bg-primary text-white" : "text-gray-900"
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      Tax Invoice
                    </button>
                  )}
                </Menu.Item>
              </div>
            </AccessControl> */}
            <div className={tw`px-1 py-1`}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleButtonClick("Hold/Release")}
                    className={tw`${
                      active ? "bg-primary text-white" : "text-gray-900"
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    Hold/Release
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
